import { getEnv } from "app/config";

export const getChainWhitelist = () => {
  const envValues = getEnv();
  return envValues?.CHAIN_WHITELIST?.split(",");
};
